import React from 'react';

/**
 * 기본 이미지 뷰 컴포넌트의 Props 인터페이스
 * @property {string} [source] - 이미지 소스 경로
 * @property {React.CSSProperties} [style] - 이미지 스타일
 * @property {(e?: any) => void} [onClick] - 클릭 이벤트 핸들러
 */
interface IDefaultImageView {
  source?: string;
  style?: React.CSSProperties;
  onClick?: (e?: any) => void;
}

/**
 * 기본 이미지 뷰 컴포넌트
 * 공통으로 사용되는 이미지 표시 컴포넌트입니다.
 * @param {IDefaultImageView} props - 이미지 뷰 컴포넌트의 props
 * @returns {JSX.Element} 기본 이미지 뷰 컴포넌트
 */
const DefaultImageView = ({source, style, onClick}: IDefaultImageView) => {
  const onErrorImg = (e: any) => {
    e.target.src = '/images/common/empty_img.png';
    e.target.style.width = '40%';
  };
  return (
    <img
      src={source?.startsWith('images/') ? `/${source}` : source}
      alt=""
      className="default_img"
      style={{
        width: 'auto',
        height: 'auto',
        ...style,
      }}
      onClick={onClick}
      onError={onErrorImg}
    />
  );
};

export default DefaultImageView;
